import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Act } from "../models/act"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ActService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'act/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllAct(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Act>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllAct?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewAct(ActID?: string): Observable<Array<Act>> {
    return this.httpService.get(this.apiEndpoint + 'viewAct/' + (ActID ? ActID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveAct(acts: Act): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveAct/', acts).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  } 

  deleteAct(ActID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteAct/' + (ActID ? ActID : '00000000-0000-0000-0000-000000000000'), ActID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(ActName?: string,ActId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?ActName=' + (ActName ? ActName : '')+ '&ActId=' + (ActId ? ActId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
